export enum PropAlignment {
	INHERIT = 'inherit',
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
	JUSTIFY = 'justify',
}

export enum PropColor {
	INHERIT = 'inherit',
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	DEFAULT = 'default',
}
